<template>
  <!--create committee modal start-->
  <div
    class="modal fade"
    id="editCommittee"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content committee-modal">
        <div class="modal-header" style="border-bottom: unset">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12 col-12 pl-md-5 pr-md-5">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <h5 class="text-uppercase" v-if="isEdit">
                    {{ committee.title }} Bewerken
                  </h5>
                  <h5 class="text-uppercase" v-else>Create a new committee</h5>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-3">
                        <img
                          :src="img ? img : committee.profile_image"
                          style="height: 100px;width: 100px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                          alt=""
                        />
                      </div>
                      <div class="col-md-9">
                        <input
                          class="mt-4 custom-file-input"
                          type="file"
                          id="editfile"
                          @change="uploadImage"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="name">Titel:</label>
                    <input
                      type="text"
                      class="form-control"
                      id="name"
                      v-model="title"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="">Omschrijving:</label>
                    <editor
                      :id="'descriptionEditor_' + committee.id"
                      v-model="description"
                      :init="{
                        height: 200,
                        menubar: false,
                        language: 'nl',
                        plugins: [
                          'advlist autolink lists link image charmap print preview anchor',
                          'searchreplace visualblocks code fullscreen',
                          'insertdatetime media table paste code help wordcount',
                        ],
                        toolbar:
                          'undo redo | formatselect | bold italic backcolor | \
                                                alignleft aligncenter alignright alignjustify | \
                                                bullist numlist outdent indent | removeformat | help',
                      }"
                    />
                  </div>
                </div>
                <div class="col-md-12 mb-3">
                  Kies leden:
                  <div style="background:#2065a2c7">
                    <members
                      v-bind:isEdit="isEdit"
                      v-bind:committee="committee"
                    ></members>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <button
                class="btn-dark float-right mt-3"
                v-if="isEdit"
                v-on:click="editCommittee"
              >
                Opslaan
              </button>
              <button
                class="btn-dark float-right mt-3"
                v-else
                v-on:click="createCommittee"
              >
                Create it
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- create committee modal end-->
</template>

<script>
import members from "./members";
import { mapState } from "vuex";

export default {
  name: "committeeModal",
  components: { members },
  props: ["isEdit", "committee", "parents_id"],
  data() {
    return {
      img: null,
      title: this.committee.title,
      description: this.committee.description,
      image: [],
      parent_id: "",
      active: 1,
    };
  },
  watch: {
    committee(newvalue) {
      this.title = newvalue.title;
      this.description = newvalue.description;
      this.img = newvalue.img_path;
      this.parent_id = newvalue.id;
    },
  },
  methods: {
    uploadImage(event) {
      var file = event.target.files[0];
      this.image = file;
      this.img = URL.createObjectURL(file);
    },
    createCommittee() {
      const formData = new FormData();
      formData.append("img", this.image);
      formData.append("title", this.title);
      formData.append("description", this.description);
      formData.append("parent_id", this.parent_id);

      var data = {
        endpoint: "/api/v1/committees",
        details: formData,
      };

      this.$store.dispatch("post", data).then((data) => {
        console.log(data);
        location.reload();
      });
    },
    editCommittee() {
      const formData = new FormData();
      if (this.image != null) {
        formData.append("img", this.image);
      }
      formData.append("title", this.title);
      formData.append("description", this.description);
      formData.append("parent_id", this.parent_id);
      formData.append("active", this.active);
      if (this.isEdit) {
        formData.append("members", JSON.stringify(this.committee.users));
      } else {
        formData.append("members", JSON.stringify(this.selectedMembers));
      }

      var data = {
        endpoint: "/api/v1/committees/update/" + this.committee.id,
        details: formData,
      };

      this.$store.dispatch("post", data).then((data) => {
        console.log(data);

        this.$store.dispatch("auth/makeNotification", {
          status: "",
          statusText: "Opgeslagen",
        });

        window.$("#editCommittee").modal("hide");
        // window.location.reload();
      });
    },
  },
  computed: {
    ...mapState({
      selectedMembers: (state) => state.selectedMembers,
    }),
  },
  created() {
    if (this.parents_id) {
      this.parent_id = this.parents_id;
    }
  },
};
</script>

<style scoped>
.committee-modal .close {
  background: transparent;
}
.committee-modal .btn-dark {
  color: white !important;
  border: none;
}
.form-control,
.input-group-text {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029;
  border-radius: 4px;
  opacity: 1;
  border: 1px #ced4da;
}
.custom-file-input {
  color: transparent;
  opacity: 1 !important;
}
.custom-file-input::-webkit-file-upload-button {
  visibility: hidden;
}
.custom-file-input::before {
  content: "Upload";
  color: white;
  display: inline-block;
  background: black;
  border-radius: 3px;
  padding: 5px 12px;
  cursor: pointer;
}
.custom-file-input:hover::before {
  border-color: black;
  outline: none;
}
.custom-file-input:active {
  outline: none;
}
.custom-file-input:active::before {
  background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
  outline: none;
}
</style>
